const MuiDialogContent = {
  styleOverrides: {
    root: {
      fontFamily: "Poppins"
    }
  }
};

export default MuiDialogContent;
